import { render, staticRenderFns } from "./mainBreadcrumbs.vue?vue&type=template&id=3dbdf582&scoped=true"
import script from "./mainBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./mainBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbdf582",
  null
  
)

export default component.exports